import brand from '@helpers/brand';
import { pinboards } from '@redux/slices/pinboards';
import { updatePinboard } from '@redux/slices/pinboards/actions/updatePinboard';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { isFulfilled } from '@reduxjs/toolkit';
import Button from '@stories/Components/Button/Button';
import LoadingIndicator from '@stories/Components/LoadingIndicator/LoadingIndicator';
import { rgba } from 'polished';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import S from '../PinboardActionDrawer.styles';
const RenamePinboard = (props) => {
    const dispatch = useAppDispatch();
    const items = useAppSelector((state) => state.pinboards.items);
    const [status, setStatus] = React.useState();
    const itemToManage = items.find((item) => item.id === props.id);
    const { handleSubmit, register } = useForm({
        defaultValues: {
            title: itemToManage?.title ?? '',
        },
    });
    if (!itemToManage) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(S.Title, null, "Rename Your Board")),
        React.createElement(S.Body, { ref: props.scrollRef }, status === 'pending' ? (React.createElement(LoadingIndicator, { bgColor: rgba(brand.green, 0.7), fgColor: brand.white, label: "Loading\u2026", layout: "absolute" })) : (React.createElement(S.Form, { id: "RenamePinboard", onSubmit: handleSubmit(handleSave) },
            React.createElement(S.Label, { htmlFor: "title" }, "Title"),
            React.createElement(S.Input, { id: "title", autoFocus: true, type: "text", ...register('title', {
                    required: `Please enter the pinboard title`,
                }) })))),
        React.createElement(S.ActionList, null,
            React.createElement(Button, { buttonType: "outline", disabled: status === 'pending', type: "button", onClick: props.onCancel }, "Cancel"),
            React.createElement(Button, { buttonType: "default", disabled: status === 'pending', form: "RenamePinboard", type: "submit" }, "Save"))));
    async function handleSave(data) {
        setStatus('pending');
        if (!itemToManage) {
            return;
        }
        const result = await dispatch(updatePinboard({
            ...itemToManage,
            ...data,
        }));
        // If action completed successfully then show success message, otherwise show error message.
        if (isFulfilled(result) && result.payload) {
            dispatch(pinboards.actions.hideDrawer());
            if (!result.payload.error) {
                toast(`Pinboard successfully renamed.`, { type: 'success' });
            }
            else {
                toast(result.payload.error, { type: 'error' });
            }
        }
        else {
            setStatus(result.meta.requestStatus);
            toast(`Error updating pinboard, please try again`, { type: 'error' });
        }
    }
};
export default RenamePinboard;
